import { axiosInstance } from "../axios-instance";
// https://restaurantapi.twhmenu.com/api/showVisitWithDate
const StatisticsServices = {
  getVisits: (payload) => axiosInstance.post(`/showVisitWithDate`, payload),
};

export default StatisticsServices;
